import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGUAGES } from 'i18n'

// Inline SVG flags so they render consistently on every OS (emoji flags don't
// show on Windows). `es` uses the Mexican flag since the users are in Mexico.
const MexicoFlag = () => (
  <svg viewBox='0 0 6 4' className='w-full h-full' aria-hidden='true'>
    <rect width='2' height='4' x='0' fill='#006847' />
    <rect width='2' height='4' x='2' fill='#ffffff' />
    <rect width='2' height='4' x='4' fill='#ce1126' />
    <circle cx='3' cy='2' r='0.55' fill='none' stroke='#8a5a2b' strokeWidth='0.18' />
  </svg>
)

const UsaFlag = () => (
  <svg viewBox='0 0 19 10' className='w-full h-full' aria-hidden='true'>
    <rect width='19' height='10' fill='#b22234' />
    {[1, 3, 5, 7, 9, 11].map(i => (
      <rect key={i} y={(i * 10) / 13} width='19' height={10 / 13} fill='#ffffff' />
    ))}
    <rect width='7.6' height={(7 * 10) / 13} fill='#3c3b6e' />
    {[0.9, 2.5, 4.1, 5.7].map(x => (
      [0.7, 2.1, 3.5].map(y => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r='0.28' fill='#ffffff' />
      ))
    ))}
  </svg>
)

const FLAGS = {
  es: MexicoFlag,
  en: UsaFlag
}

// variant: 'light' (default, for light backgrounds like the login card)
//          'dark'  (for the dark sidebar)
const LanguageSwitcher = ({ variant = 'light', className = '' }) => {
  const { i18n, t } = useTranslation()
  const currentLng = (i18n.resolvedLanguage || i18n.language || 'es').split('-')[0]

  const ringActive = variant === 'dark' ? 'ring-2 ring-white' : 'ring-2 ring-green-500'

  return (
    <div
      role='group'
      aria-label={t('language.label')}
      className={`flex items-center gap-1.5 ${className}`}
    >
      {SUPPORTED_LANGUAGES.map(lng => {
        const Flag = FLAGS[lng]
        if (!Flag) return null
        const isActive = currentLng === lng
        return (
          <button
            key={lng}
            type='button'
            onClick={() => i18n.changeLanguage(lng)}
            aria-pressed={isActive}
            aria-label={t(`language.${lng}`)}
            title={t(`language.${lng}`)}
            className={`w-6 h-4 rounded-sm overflow-hidden border border-black/10 shadow-sm transition-opacity ${isActive ? `${ringActive} opacity-100` : 'opacity-50 hover:opacity-100'}`}
          >
            <Flag />
          </button>
        )
      })}
    </div>
  )
}

export default LanguageSwitcher
